export interface MacrosInput {
  id?: string;
  providerId: string;
  scribeId?: string;
  type: string;
  name: string;
  content: string;
  context?: string;
  created?: string;
  updated?: string;
  deleted?: string;
  section: string;
  attributes: MacrosAttribute[];
}

export interface MacrosAttribute {
  key: string;
  value: string;
}

export interface DeleteMacroInput {
  macroId: string;
}

export enum MacrosType {
  PROVIDER = 'PROVIDER',
}
